module.exports = __webpack_public_path__ + "static/img/boardBomManagement.d57afd07.png";